import React from 'react';
import type { CompletionTimeByUserRow } from '../../types/dashboard';

interface Props {
  data: CompletionTimeByUserRow[] | null;
}

export default function CompletionTimeByUserTable({ data }: Props) {
  return (
    <div style={sectionStyle}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
        <h3 style={headingStyle}>PNID Completion Time by User</h3>
        <div style={metaStyle}>Avg completion time computed from open → completion events</div>
      </div>

      {!data || data.length === 0 ? (
        <div style={{ padding: 24, textAlign: 'center', color: '#9ca3af' }}>No data</div>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table style={tableStyle}>
            <thead>
              <tr>
                {COLUMNS.map((col) => (
                  <th key={col.key} style={thStyle}>
                    {col.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((row) => (
                <tr key={row.user} style={{ borderBottom: '1px solid #f3f4f6' }}>
                  <td style={tdStyle}>{row.user}</td>
                  <td style={tdNumStyle}>{row.completed_7d}</td>
                  <td style={tdNumStyle}>{row.avg_minutes_7d.toFixed(1)}</td>
                  <td style={tdNumStyle}>{row.completed_30d}</td>
                  <td style={tdNumStyle}>{row.avg_minutes_30d.toFixed(1)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

const COLUMNS = [
  { key: 'user', label: 'User' },
  { key: 'completed_7d', label: 'Completed (7d)' },
  { key: 'avg_minutes_7d', label: 'Avg Time (7d, min)' },
  { key: 'completed_30d', label: 'Completed (30d)' },
  { key: 'avg_minutes_30d', label: 'Avg Time (30d, min)' },
];

const sectionStyle: React.CSSProperties = {
  backgroundColor: '#fff',
  borderRadius: 12,
  padding: 24,
  boxShadow: '0 1px 3px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.06)',
};

const headingStyle: React.CSSProperties = {
  fontSize: 16,
  fontWeight: 600,
  color: '#111827',
  margin: 0,
};

const metaStyle: React.CSSProperties = {
  fontSize: 12,
  color: '#6b7280',
};

const tableStyle: React.CSSProperties = {
  width: '100%',
  borderCollapse: 'collapse',
  fontSize: 13,
};

const thStyle: React.CSSProperties = {
  textAlign: 'left',
  padding: '8px 12px',
  fontSize: 11,
  fontWeight: 600,
  color: '#6b7280',
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  borderBottom: '2px solid #e5e7eb',
  whiteSpace: 'nowrap',
};

const tdStyle: React.CSSProperties = {
  padding: '10px 12px',
  color: '#374151',
  fontWeight: 500,
};

const tdNumStyle: React.CSSProperties = {
  ...tdStyle,
  textAlign: 'right',
  fontVariantNumeric: 'tabular-nums',
};

